import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import { addStore } from 'common/util';
import FieldFactory from 'common/components/field-factory';
// import EditImage from 'common/components/edit-image';
import EditImage from 'client/shared/components/edit-image/edit-image';
import Editor from 'common/components/editor';

import SongList from './song-list';

const ALBUM_LINER_NOTES_KEY = 'album.linerNotes';
const ALBUM_ARTIST_ID_KEY = 'album.artistID';
const ALBUM_ARTWORK_KEY = 'album.artwork';

@inject('formStore', 'albumsStore', 'artistStore')
@observer
class AlbumForm extends Component {
	constructor (props) {
		super(props);

		this.state = {
			albumArtwork: null
		};
	}

	render () {
		const { albumsStore, formStore, artistStore, handleImageCrop } = this.props;
		const content = albumsStore.get(ALBUM_LINER_NOTES_KEY);
		const FieldWithStore = addStore(FieldFactory, {
			formStore,
			store: albumsStore
		});

		albumsStore.set({
			key: ALBUM_ARTIST_ID_KEY,
			value: artistStore.data.artist.get('_id')
		});

		return (
			<div className='grid-container album-form'>
				<div className="grid-x">
					<div className="cell">
						<h4>New Album</h4>
						<FieldWithStore fieldKey="album.artistID" defaultValue={ albumsStore.data.album.get('artistID') } />
						<FieldWithStore fieldKey="album.artwork" />
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-8">
						<FieldWithStore fieldKey="album.name" />

						<div className="hfm-field">
							<label>Liner Notes</label>
							<Editor onChange={ this.onChange } content={ content } />
						</div>
					</div>

					<div className="cell auto">
						<EditImage
							imgSrc={ albumsStore.get(ALBUM_ARTWORK_KEY) }
							store={ albumsStore }
							handleImageCrop={ handleImageCrop } />
					</div>
				</div>

				<div className="grid-x">
					<div className="cell small-=12">
						<SongList />
					</div>
				</div>
			</div>
		);
	}

	@autobind
	onChange (content) {
		const { albumsStore } = this.props;

		albumsStore.set({
			key: ALBUM_LINER_NOTES_KEY,
			value: content
		});
	}
}

export default AlbumForm;
